import {ApiClient} from '@hconnect/apiclient'
import {HttpError} from '@hconnect/common/types'
import {useQueries, UseQueryResult} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {QueryOptions2Type, SignalsListType} from '../types'

export const SignalsQueryKey = 'signals'

type UseGetSignalsParams = {
  entity: 'plant' | 'area' | 'department' | 'equipment'
  entityId: string
}

export const useGetUpmSignalsMultiple = <T extends UseGetSignalsParams>(
  entities: T[],
  options?: QueryOptions2Type<SignalsListType[], AxiosError<HttpError>>
): UseQueryResult<SignalsListType[], AxiosError<HttpError>>[] => {
  return useQueries({
    queries: entities.map((entity) => {
      return {
        queryKey: [SignalsQueryKey, entity.entity, entity.entityId],
        queryFn: async () => {
          const path = `/upm/signal/${entity.entity}/${entity.entityId}?pageSize=1000`
          return (await ApiClient.axiosInstance.get(path)).data
        },
        ...options
      }
    })
  })
}
